export const TASKS_WITHOUT_TEXT_DATA_TO_REJECT = [
  'construction_budget',
  'dscr',
  'purchase',
  'entity_docs',
  'track_record', // past investment experience
  'investment_experience'
]